import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi/useApi.ts";
import type { PersonResponse } from "~types/person.ts";

export const useFetchPerson = (personId: string) => {
  const enhancedRequest = useApi();
  const { organizationId, sport } = useParams();
  const url = `${sport}/o/${organizationId}/persons/${personId}`;

  return useQuery({
    queryKey: ["person", sport, organizationId, personId],
    queryFn: async () => {
      const response: PersonResponse = await enhancedRequest(url);
      return response?.data[0];
    },
  });
};
